import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage(): ReactElement {
  return (
    <div className="carte">
      <h1>Page introuvable</h1>
      <p className="sous-titre">L&apos;adresse demandée ne correspond à aucune page.</p>
      <Link to="/tableau-de-bord">Revenir au tableau de bord</Link>
    </div>
  );
}
